import Vue from 'vue'
import VueRouter from 'vue-router'

import Landing from '../views/Landing.vue'
import Intro from '../views/Intro.vue'
import Welcome from '../views/Welcome.vue'
import Setup from '../views/Setup.vue'
import Logs from '../views/Logs.vue'
import Reports from '../views/Reports.vue'
import Transition from '../views/Transition.vue'
import Settings from '../views/Settings.vue'
import Outro from '../views/Outro.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'landing',
    component: Landing
  },
  {
    path: '/intro',
    name: 'intro',
    component: Intro
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: Welcome
  },
  {
    path: '/setup',
    name: 'setup',
    component: Setup
  },
  {
    path: '/logs',
    name: 'logs',
    component: Logs
  },
  {
    path: '/reports',
    name: 'reports',
    component: Reports
  },
  {
    path: '/transition',
    name: 'transition',
    component: Transition
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings
  },
  {
    path: '/outro',
    name: 'outro',
    component: Outro
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// always push back to landing when hard loading
router.beforeEach((to, from, next) => {
  if (from.fullPath === '/' && from.name === null && to.path !== '/') {
    next({ name: 'landing' });
  } else {
    next();
  }
})

export default router
